import type { SVGProps } from "react";
export interface ListNumberIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function ListNumberIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: ListNumberIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="m20.25 17.62.116.006a1.125 1.125 0 0 1 0 2.238l-.116.006h-9a1.125 1.125 0 0 1 0-2.25zm0-6.701.116.005a1.126 1.126 0 0 1 0 2.239l-.116.006h-9a1.125 1.125 0 0 1 0-2.25zm0-6.794a1.125 1.125 0 0 1 0 2.25h-9a1.125 1.125 0 0 1 0-2.25zM5.9 11.043v-.027a.58.58 0 0 0-.15-.394.34.34 0 0 0-.25-.122.49.49 0 0 0-.431.334l-.769-.21-.768-.208C3.782 9.606 4.592 9 5.5 9c1.2 0 2 1.006 2 2.016v.027c0 .6-.25 1.053-.61 1.39-.325.3-.735.5-1.018.64-.33.162-.522.26-.653.373a1 1 0 0 0-.056.054H6.7c.442 0 .8.336.8.75s-.358.75-.8.75H4.433a.91.91 0 0 1-.933-.89v-.422c0-.593.27-1.03.632-1.344.319-.277.727-.468.996-.6.317-.156.507-.26.633-.377a.39.39 0 0 0 .14-.324Zm-.831-.209c-.123.398-.566.626-.99.511s-.67-.53-.547-.929zm.494-8.831a.76.76 0 0 1 .706.747V6.5h.962A.76.76 0 0 1 8 7.25a.76.76 0 0 1-.77.75H3.77A.76.76 0 0 1 3 7.25a.76.76 0 0 1 .77-.75h.96V4.51a3 3 0 0 1-.594.109l-.186.006h-.18a.76.76 0 0 1-.77-.75.76.76 0 0 1 .77-.75h.18l.195-.013c.418-.058.563-.294.572-.346l.024-.14a.765.765 0 0 1 .822-.623m.771 17.981c0-.17-.235-.515-.834-.515h-.037c-.46 0-.833-.336-.833-.75s.373-.75.833-.75h.075l.12-.009a.6.6 0 0 0 .259-.103c.075-.057.083-.104.083-.123s-.008-.065-.083-.123a.64.64 0 0 0-.38-.111h-.074c-.256 0-.402.114-.444.18l-.098.125a.9.9 0 0 1-1.038.16c-.4-.202-.543-.66-.318-1.02l.158-.213c.404-.467 1.06-.732 1.74-.732h.075c1.037 0 2.128.662 2.128 1.734 0 .347-.115.649-.304.901.387.342.638.802.638 1.35C8 21.211 6.743 22 5.5 22c-.979 0-2.069-.479-2.444-1.355l.778-.27.778-.27c.059.137.386.395.888.395.599 0 .834-.345.834-.516m-2.8-.309c.43-.149.912.043 1.078.43l-1.556.54c-.166-.386.049-.82.478-.97"
      />
    </svg>
  );
}
